import axios from 'axios';
import keycloak from '../auth/AuthContext';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api',
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use(async (config) => {
  if (keycloak.authenticated) {
    await keycloak.updateToken(60).catch(() => keycloak.login());
    config.headers.Authorization = `Bearer ${keycloak.token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) keycloak.login();
    return Promise.reject(err);
  }
);

// ─── Bookings ──────────────────────────────────────────────────
export const bookingApi = {
  getAll: (from, to) => api.get('/bookings', { params: { from, to } }),
  create: (data) => api.post('/bookings', data),
  update: (id, data) => api.put(`/bookings/${id}`, data),
  cancel: (id) => api.delete(`/bookings/${id}`),
  checkAvailability: (starts_at, ends_at, booking_id, staff_id) =>
    api.post('/bookings/check-availability', { starts_at, ends_at, booking_id, staff_id })
};

// ─── Staff ────────────────────────────────────────────────────
export const staffApi = {
  getAll:  ()         => api.get('/staff'),
  create:  (data)     => api.post('/staff', data),
  update:  (id, data) => api.put(`/staff/${id}`, data),
  delete:  (id)       => api.delete(`/staff/${id}`)
};

// ─── Services ─────────────────────────────────────────────────
export const serviceApi = {
  getAll:  ()         => api.get('/services'),
  create:  (data)     => api.post('/services', data),
  update:  (id, data) => api.put(`/services/${id}`, data),
  delete:  (id)       => api.delete(`/services/${id}`)
};

// ─── Clients ──────────────────────────────────────────────────
export const clientApi = {
  search: (q)    => api.get('/clients', { params: { search: q } }),
  create: (data) => api.post('/clients', data),
  update: (id, data) => api.put(`/clients/${id}`, data)
};

// ─── AI ───────────────────────────────────────────────────────
export const aiApi = {
  getStatus: () => api.get('/ai/status')
};

// ─── Salon Settings ───────────────────────────────────────────
export const salonApi = {
  getSettings:    ()     => api.get('/salon/settings'),
  updateSettings: (data) => api.put('/salon/settings', data)
};

export default api;